import { useVisualizerStore } from '@/stores/useVisualizerStore';
import { useTenant } from '@/utils/tenant';

function BrandIcon() {
  return (
    <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
      />
    </svg>
  );
}

export function Header() {
  const appState = useVisualizerStore((s) => s.appState);
  const reset = useVisualizerStore((s) => s.reset);
  const tenant = useTenant();

  const showBack = appState === 'PREVIEW' || appState === 'SAVING' || appState === 'ERROR';

  return (
    <header className="flex items-center justify-between border-b border-blue-100/80 bg-white/90 px-4 py-3 backdrop-blur-md">
      <div className="flex items-center gap-3">
        {showBack && (
          <button
            onClick={reset}
            className="rounded-lg p-2 text-slate-500 transition-colors hover:bg-blue-50 hover:text-slate-900"
            aria-label="Go back"
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
          </button>
        )}
        <div className="flex items-center gap-2.5">
          {/* Brand icon / logo */}
          <div
            className="flex h-9 w-9 items-center justify-center rounded-xl text-white shadow-lg"
            style={{
              backgroundColor: `rgb(var(--color-primary))`,
              boxShadow: `0 4px 12px rgb(var(--color-primary) / 0.3)`,
            }}
          >
            {tenant.logoUrl ? (
              <img
                src={tenant.logoUrl}
                alt={tenant.businessName}
                className="h-7 w-7 rounded-lg object-contain"
                onError={(e) => {
                  (e.currentTarget as HTMLImageElement).style.display = 'none';
                  (e.currentTarget.nextElementSibling as HTMLElement | null)?.style.setProperty(
                    'display',
                    'block'
                  );
                }}
              />
            ) : null}
            <span style={{ display: tenant.logoUrl ? 'none' : 'block' }}>
              <BrandIcon />
            </span>
          </div>

          {/* Business name + tagline */}
          <div className="flex flex-col leading-tight">
            <div className="flex items-baseline gap-1.5">
              <h1 className="text-lg font-bold tracking-tight text-slate-900">
                {tenant.businessName}
              </h1>
            </div>
            {tenant.website && (
              <a
                href={tenant.website}
                target="_blank"
                rel="noopener noreferrer"
                className="text-[11px] font-medium transition-colors hover:opacity-80"
                style={{ color: `rgb(var(--color-primary))` }}
              >
                {tenant.tagline || tenant.website.replace(/^https?:\/\/(www\.)?/, '')}
              </a>
            )}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-3">
        <a
          href="https://countervision-web.pages.dev"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden items-center gap-1.5 text-xs font-medium text-slate-500 transition-colors hover:text-slate-900 sm:flex"
        >
          CounterVision
          <span className="rounded-full bg-emerald-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-700">
            New
          </span>
        </a>
        <a
          href="https://tubvision.com"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden items-center gap-1.5 text-xs font-medium text-slate-500 transition-colors hover:text-slate-900 sm:flex"
        >
          TubVision
          <span className="rounded-full bg-emerald-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-emerald-700">
            New
          </span>
        </a>
        {showBack && (
          <button
            onClick={reset}
            className="text-sm font-medium transition-colors hover:opacity-80"
            style={{ color: `rgb(var(--color-primary))` }}
          >
            Start Over
          </button>
        )}
      </div>
    </header>
  );
}
